// Alert.alert implemented with plain DOM so it works outside of React trees.
const css = {
  overlay:
    "position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(15,23,42,.5);z-index:3000;display:flex;align-items:center;justify-content:center;font-family:Inter,system-ui,sans-serif;",
  box:
    "background:#fff;border-radius:16px;min-width:300px;max-width:440px;width:80%;padding:24px 24px 16px;box-shadow:0 20px 50px rgba(15,23,42,.3);",
  title: "font-size:18px;font-weight:700;color:#0f172a;margin:0 0 8px;",
  message:
    "font-size:15px;color:#64748b;margin:0 0 20px;white-space:pre-wrap;line-height:1.5;",
  actions: "display:flex;justify-content:flex-end;flex-wrap:wrap;gap:8px;",
  button:
    "background:#f1f5f9;border:0;color:#0f172a;font-family:inherit;font-size:14px;font-weight:600;padding:10px 18px;cursor:pointer;border-radius:10px;min-width:84px;",
  toast:
    "position:fixed;left:50%;bottom:40px;transform:translateX(-50%);background:#0f172a;color:#fff;padding:10px 18px;border-radius:12px;z-index:3100;font-family:Inter,system-ui,sans-serif;font-size:14px;",
};

function el(tag, style, text) {
  const node = document.createElement(tag);
  node.style.cssText = style;
  if (text !== undefined && text !== null) {
    node.textContent = String(text);
  }
  return node;
}

const Alert = {
  alert(title, message, buttons, options) {
    const list = buttons && buttons.length ? buttons : [{ text: "OK" }];
    const overlay = el("div", css.overlay);
    const box = el("div", css.box);
    const close = () => {
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    };

    if (title) {
      box.appendChild(el("h3", css.title, title));
    }
    if (message) {
      box.appendChild(el("p", css.message, message));
    }
    const actions = el("div", css.actions);
    list.forEach(button => {
      const node = el("button", css.button, button.text || "OK");
      const last = list.indexOf(button) === list.length - 1;
      if (button.style === "destructive") {
        node.style.background = "#ef4444";
        node.style.color = "#fff";
      } else if (last && button.style !== "cancel") {
        // the confirming action is the prominent one
        node.style.background = "#2563eb";
        node.style.color = "#fff";
      }
      node.addEventListener("click", () => {
        close();
        if (button.onPress) {
          button.onPress();
        }
      });
      actions.appendChild(node);
    });
    box.appendChild(actions);
    overlay.appendChild(box);

    if (options && options.cancelable) {
      overlay.addEventListener("click", e => {
        if (e.target === overlay) {
          close();
          if (options.onDismiss) {
            options.onDismiss();
          }
        }
      });
    }
    document.body.appendChild(overlay);
    const last = actions.lastChild;
    if (last) {
      last.focus();
    }
  },

  toast(message, duration = 2500) {
    const node = el("div", css.toast, message);
    document.body.appendChild(node);
    setTimeout(() => {
      if (node.parentNode) {
        node.parentNode.removeChild(node);
      }
    }, duration);
  },
};

export default Alert;
